import { render, staticRenderFns } from "./BalanceTag.vue?vue&type=template&id=d2d083f8&scoped=true&"
import script from "./BalanceTag.vue?vue&type=script&lang=js&"
export * from "./BalanceTag.vue?vue&type=script&lang=js&"
import style0 from "./BalanceTag.vue?vue&type=style&index=0&id=d2d083f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d083f8",
  null
  
)

export default component.exports